import React, { SyntheticEvent, useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Title from '../../../components/Title';
import { User } from '../../../models/user';
import { Office } from '../../../models/office';
import { useTheme, useMediaQuery, Divider, CardActions, TextField, Button, Box, Card, Grid, FormControl, MenuItem, InputLabel, Select, CardContent, FormControlLabel, Switch, Checkbox } from '@mui/material';
import HeaderResponsive from '../../../components/layouts/HeaderResponsive';
import { nowOperationalDateTimeString, operationalMoment } from '../../../utils/operationalDateTime';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const CobrosAdd: React.FC<ShowAlerts> = ({ showAlert, showLoading, hideLoading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [user_id, setUser_id] = useState('');
  const [office_id, setOffice_id] = useState('');
  const [quote, setQuote] = useState('');
  const [days_insurance, setDays_insurance] = useState('0');
  const [insurance, setInsurance] = useState('0');
  const [cons_insurance, setCons_insurance] = useState('0');
  const [cons_insurance_manual, setCons_insurance_manual] = useState(true);
  const [enable_quote_client, setEnable_quote_client] = useState(false);
  const [users, setUsers] = useState([]);
  const [offices, setOffices] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      showLoading();
      try {
        const [employeeResponse, officesResponse, userData] = await Promise.all([
          axios.get('employeesNoCollect'), // Cambio a 'employees' cuando se tenga la ruta
          axios.get('alloffices'),
          axios.get("user"),

        ]);
        setUsers(employeeResponse.data.data);
        setOffices(officesResponse.data.data);
        setUser_id(userData.data.id);
        await new Promise(resolve => setTimeout(resolve, 1000)); // Esperar 3 segundos
      } catch (error) {
        showAlert('Error fetching data!', 'error');
      } finally {
        hideLoading();
      }
    };
    fetchData();
  }, []);

  const submit = async (event: SyntheticEvent) => {
    event.preventDefault(); // Evita el envío del formulario por defecto
    if (!name || !user_id || !office_id || !quote) {
      showAlert('Tiene campos pendientes por diligenciar!', 'warning');
      return;
    }

    const ingress_date = operationalMoment().toDate();
    const boxDate = nowOperationalDateTimeString();
    const formData = {
      currentDate: boxDate,
      name,
      ingress_date,
      office_id,
      user_id,
      quote,
      days_insurance,
      insurance,
      cons_insurance,
      cons_insurance_manual,
      valid_time: false,
      detail_machine: true,
      delete_pay: true,
      delete_lend: true,
      enable_quote_client,
    }

    const url = '/collects'
    try {
      showLoading();
      const response = await axios.post(url, formData);
      await new Promise((response) => setTimeout(response, 200));
      showAlert('Se ha realizado la consulta exitosamente!', 'info');
      navigate('/administrar/cobros');
    } catch (error) {
      console.error('Error fetching data: ', error);
      showAlert('Error fetching data!', 'error');
    } finally {
      hideLoading();
    }
  }

  return (
    <HeaderResponsive>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>

        <Title>Agregar Cobro</Title>

      </Box>
      <Card sx={{ mb: { xs: 10, md: 12 } }}>
        {/* <CardHeader title='Multi Column with Form Separator' titleTypographyProps={{ variant: 'h6' }} /> */}
        <Divider sx={{ margin: 0 }} />
        <form onSubmit={submit}>
          <CardContent sx={{ pb: 3 }}>
             <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='text' label='Nombre' placeholder='Rufino' onChange={event => setName(event.target.value)} inputProps={{ maxLength: 30 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' label='Cupo' type='number' placeholder='0' id="manager" onChange={event => setQuote(event.target.value)} inputProps={{ maxLength: 10, min: 0 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' label='Regla días descuento' type='number' placeholder='0' value={days_insurance} onChange={event => setDays_insurance(event.target.value)} inputProps={{ min: 0 }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size='small'
                  label='Valor gasto gestión por base'
                  type='number'
                  placeholder='0'
                  value={insurance}
                  onChange={event => setInsurance(event.target.value)}
                  inputProps={{ min: 0 }}
                  helperText='Ejemplo: si cobra 4 por cada 100, aquí va 4.'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size='small'
                  label='Base de cálculo'
                  type='number'
                  placeholder='0'
                  value={cons_insurance}
                  onChange={event => setCons_insurance(event.target.value)}
                  inputProps={{ min: 0 }}
                  helperText='Ejemplo: si cobra 4 por cada 100, aquí va 100.'
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={enable_quote_client}
                      onChange={(e) => setEnable_quote_client(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Préstamos: usar cupo del cliente (si está apagado, se usa el cupo del cobro)"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={cons_insurance_manual}
                      onChange={(event) => setCons_insurance_manual(event.target.checked)}
                    />
                  }
                  label='Gasto gestión manual'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size='small'>
                  <InputLabel id='form-layouts-separator-select-label'>Seleccionar Empleado</InputLabel>
                  {users && users.length > 0 ? (
                    <Select
                      size='small'
                      label='Usuario'
                      defaultValue=""
                      id='form-layouts-separator-select'
                      labelId='form-layouts-separator-select-label'
                      onChange={event => setUser_id(event.target.value)}
                      required
                    >
                      {users.map((user: User) => {
                        // Agregar un console.log para mostrar el valor de collect.user.id
                        return (
                          <MenuItem key={user.id} value={user.id}>
                            {user.first_name} {user.last_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : null}
                </FormControl>

              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size='small'>
                  <InputLabel id='form-layouts-separator-select-label'>Seleccionar Oficina</InputLabel>
                  {offices && offices.length > 0 ? (
                    <Select
                      size='small'
                      label='Oficina'
                      defaultValue=''
                      id='form-layouts-separator-select'
                      labelId='form-layouts-separator-select-label'
                      onChange={event => setOffice_id(event.target.value)}
                      required
                    >
                      {offices.map((office: Office) => {
                        return (
                          <MenuItem key={office.id} value={office.id}>
                            {office.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
          <Divider sx={{ margin: 0 }} />
          <CardActions sx={{ px: 3, py: 2, bgcolor: 'background.paper' }}>
            <Button size='small' type='submit' sx={{ mr: 2 }} variant='contained'>
              Guardar
            </Button>
            <Link to='/administrar/cobros'>
              <Button size='small' color='secondary' variant='outlined'>
                Cancelar
              </Button>
            </Link>
          </CardActions>
        </form>
      </Card>

    </HeaderResponsive>

  )
}

export default CobrosAdd
